<template>
	<div class="social-index-wrap">
		<div class="nav-wrap">
			<div class="flex">
				<i class="iconfont icon-home1"></i>
				<router-link class="link" to="/">首页</router-link>
				<i class="el-icon-arrow-right"></i>
				<router-link class="link" to="/server/main">信用服务</router-link>
				<i class="el-icon-arrow-right"></i>
				<router-link class="link" :to="$route.path" replace><span>信用社区</span></router-link>
			</div>
		</div>
		<div class="social-box">
			<div class="inner-top">
				<div class="inner-top-title">让社区诚信体系更完善</div>
				<el-input placeholder="请输入身份证号查询" v-model="search" clearable @clear="searchClear">
					<el-button slot="append" icon="el-icon-search" @click="searchHandle"></el-button>
				</el-input>
			</div>
			<!-- <div class="inner">
				<div class="inner-bottom-title flex">
					<span>查询结果</span>
				</div>
				<div class="table-wrap">
					<el-table :data="list" :header-row-style="headerClass" v-if="list.length">
						<el-table-column label="内容" prop="indexName" width="700px" align="center"></el-table-column>
						<el-table-column label="时间" prop="scoreTime" align="center"></el-table-column>
						<el-table-column label="分值" prop="score" align="center">
							<template slot-scope="{ row }">
								<span :style="{ color: row.score >= 0 ? '#D01C0B' : '' }">{{ row.score }}</span>
							</template>
						</el-table-column>
					</el-table>
					<div class="flex flex-row-end page-wrap" v-if="list.length > 0">
						<el-pagination background layout="total, prev, pager, next" :pageSize="pageSize" :total="total" @current-change="handleCurrentChange"> </el-pagination>
					</div>
					<empty v-if="!list.length" />
				</div>
			</div> -->
			<div class="inner-mid" v-if="score.idNumber">
				<div class="">
					<div class="u-flex">
						<div class="top-box-left">
							<div class="top-box-name">
								{{ score.name }}
							</div>
							<div class="top-box-id">
								{{ score.idNumber }}
							</div>
						</div>
						<div class="top-box-right">
							<div class="top-box-level">
								{{ score.level }}
							</div>
							<div class="top-box-text">信用等级</div>
						</div>
					</div>
					<div class="score-box u-flex">
						<div class="">
							<div class="number">
								{{ score.score || 0 }}
							</div>
							<div class="num-text">当前分值</div>
						</div>
						<div class="">
							<div class="number">
								<!-- {{ score.basicScore || 0 }} -->
                                1000
							</div>
							<div class="num-text">基本分值</div>
						</div>
					</div>
				</div>
			</div>
			<div class="inner">
				<div class="inner-bottom-title flex">
					<span>分值记录</span>
				</div>
				<div class="table-wrap">
					<el-table :data="list" :header-row-style="headerClass" v-if="list.length">
						<el-table-column label="内容" prop="indexName" width="700px" align="center"></el-table-column>
						<el-table-column label="时间" prop="scoreTime" align="center"></el-table-column>
						<el-table-column label="分值" prop="score" align="center">
							<template slot-scope="{ row }">
								<span :style="{ color: row.score >= 0 ? '#D01C0B' : '' }">{{ row.score }}</span>
							</template>
						</el-table-column>
					</el-table>
					<div class="flex flex-row-end page-wrap" v-if="list.length > 0">
						<el-pagination background layout="total, prev, pager, next" :pageSize="pageSize" :total="total" @current-change="handleCurrentChange"> </el-pagination>
					</div>
					<empty v-if="!list.length" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import empty from '@/components/empty';
import { peopleScoreList, peopleScore } from '@/api';

export default {
	components: {
		empty
	},
	data() {
		return {
			search: '',
			score: {},

			list: [],
			pageSize: 10,
			total: 0
		};
	},
	created() {},
	mounted() {},
	methods: {
		searchClear() {
			this.$set(this, 'score', {});
			this.$set(this, 'list', []);
		},
		searchHandle() {
			if (!this.search) {
				return this.$message({
					message: '请输入身份证号查询',
					type: 'warning'
				});
			}
			this.queryScore();
			this.queryList();
		},
		queryScore() {
			peopleScore({
				idNumber: this.search
			}).then((res) => {
				this.$set(this, 'score', res || {});
			});
		},
		queryList(page = 1) {
			peopleScoreList({
				idNumber: this.search,
				current: page,
				size: this.pageSize
			}).then((res) => {
				const { records = [], total } = res || {};
				if (records.length > 0) {
					this.list = records;
				}
				this.total = total;
			});
		},
		handleCurrentChange(e) {
			this.queryList(e);
		}
	},
	computed: {},
	watch: {}
};
</script>
<style lang='scss' scoped>
	.social-index-wrap {
		background-color: #fff;
		.page-wrap {
			margin-top: 20px;
			.el-pagination {
				padding: 0;
			}
		}
		.social-box {
			.inner {
				width: 1280px;
				margin: 20px auto;
			}

			.inner-top {
				padding: 49px 0 88px;
				display: flex;
				align-items: center;
				flex-direction: column;
				.inner-top-title {
					color: #d11d0f;
					text-align: center;
					font-size: 18px;
					margin-bottom: 26px;
				}

				.el-input {
					margin: 0 auto;
				}
			}

			.inner-mid {
				background-color: #f5f5f5;
				padding: 40px 0;

				& > div {
					width: 1280px;
					margin: 0 auto;
					display: flex;
					align-items: center;
					justify-content: space-between;

					& > .u-flex {
						width: calc((100% - 20px) / 2);
						&:first-of-type {
							height: 168px;
							background: #ffffff;
							box-shadow: 0px 10px 20px 2px rgba(221, 226, 233, 0.35), -7px -7px 20px 2px #ffffff;
							display: flex;
							justify-content: space-between;
							padding: 33px 64px 0 97px;

							.top-box-left {
								padding-top: 16px;
								.top-box-name {
									font-size: 30px;
									line-height: 1;
									font-weight: bold;
									color: #333333;
								}
								.top-box-id {
									margin-top: 30px;
									font-size: 14px;
									line-height: 1;
									font-weight: 500;
									color: #666666;
								}
							}

							.top-box-right {
								text-align: center;

								.top-box-level {
									font-size: 80px;
									font-family: PingFang SC;
									font-weight: bold;
									color: #fe3e3b;
									line-height: 50px;
								}
								.top-box-text {
									font-size: 14px;
									font-family: PingFang SC;
									font-weight: 400;
									color: #999999;
									margin-top: 30px;
								}
							}
						}
						&.score-box {
							height: 168px;
							background: url('../../static/images/server/bg_fen.png') no-repeat;
							background-size: 100% 100%;
							display: flex;
							justify-content: space-around;
							& > div {
								padding: 33px 30px 0;
								div {
									text-align: center;
								}
							}
							.number {
								font-size: 60px;
								line-height: 60px;
								font-weight: 500;
								color: #ffffff;
							}
							.num-text {
								font-size: 24px;
								line-height: 1;
								margin-top: 30px;
								font-weight: 400;
								color: #ffffff;
							}
						}
					}
				}
			}
			.inner {
				border: 1px solid #e5e5e5;
				background-color: #fff;

				.inner-bottom-title {
					padding: 0 37px;
					background: #f5f5f5;
					height: 60px;
					span {
						line-height: 60px;
						font-size: 18px;
						color: #313131;
					}
				}

				.table-wrap {
					padding: 0 35px 35px;
					.el-table {
						margin-top: 16px;
					}
				}
			}
		}

		.header-background {
			background-color: #f4f4f4;

			th {
				background-color: #f4f4f4;
			}
		}
	}
</style>